import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      nav: { experiences: 'Expériences', projects: 'Projets', services: 'Services', contact: 'Contact' },
      footer: { tagline: 'Développeuse Frontend passionnée par React et TypeScript.', home: 'Accueil', projects: 'Projets', resume: 'CV', contact: 'Contact', copyright: 'Tous droits réservés.' },
      home: {
        greeting: 'Salut, je suis',
        role: "Recherche Alternance Développeur Web • Assistant Chef de projet informatique",
        intro:"Je recherche une alternance de 2 ans pour devenir assistante chef de projet, avec de solides appétences en développement frontend.",
        downloadCv: 'Télécharger mon CV',
        contactMe: 'Me contacter',
        discover: 'Découvrir',
        personalProjects: 'Mes projets personnels récents',
        professionalProjects: 'Les projets professionnels en entreprise',
        academicProjects: 'Mes projets académiques',
        viewProject: 'Voir le projet',
        viewDetails: 'Voir le détail',
        product: 'Le produit',
        operation: 'Fonctionnement',
        technologies: 'Technologies',
        viewRecommendation: 'Voir la recommandation',
        skills: 'Mes expériences',
        skillsSubtitle: 'Avec ces logiciels et technologies',
        experienceSubtitle: 'Professionnelles les plus intéressantes',
        recommendations: 'Recommandations',
        recommendationsSubtitle: "Des retours de personnes avec qui j'ai eu le plaisir de collaborer",
        education: 'Mes formations',
        educationSubtitle: 'Suivies ces dernières années',
        contactTitle: 'Contactez-moi',
        contactSubtitle: "Que vous souhaitiez collaborer, échanger sur des projets numériques, ou simplement discuter — n'hésitez pas à me contacter.",
        phoneNumber: '06 05 60 85 36',
        location: 'France (Paris, Bordeaux)',
        contractDuration: 'Alternance',
        grayscaleLabel: 'Activer ou désactiver le mode gris',
        backToTop: 'Retour en haut de la page',
        actionPhoto: "Photo d'action {{number}}"
      }
    }
  },
  en: {
    translation: {
      nav: { experiences: 'Experience', projects: 'Projects', services: 'Skills', contact: 'Contact' },
      footer: { tagline: 'Frontend developer passionate about React and TypeScript.', home: 'Home', projects: 'Projects', resume: 'Resume', contact: 'Contact', copyright: 'All rights reserved.' },
      home: {
        greeting: "Hi, I'm",
        role: 'Frontend Developer • React & TypeScript',
        intro: 'I am looking for a 2-year apprenticeship to become an assistant project manager, with strong skills in frontend development.',
        downloadCv: 'Download my resume',
        contactMe: 'Contact me',
        discover: 'Discover',
        personalProjects: 'My recent personal projects',
        professionalProjects: 'Professional projects in a company setting',
        academicProjects: 'Academic projects',
        viewProject: 'View project',
        viewDetails: 'View details',
        product: 'The product',
        operation: 'How it works',
        technologies: 'Technologies',
        viewRecommendation: 'View recommendation',
        skills: 'My skills',
        skillsSubtitle: 'Software and technologies I use',
        experienceSubtitle: 'My most relevant professional experience',
        recommendations: 'Recommendations',
        recommendationsSubtitle: 'Feedback from people I have had the pleasure of working with',
        education: 'Education',
        educationSubtitle: 'Completed in recent years',
        contactTitle: 'Contact me',
        contactSubtitle: "Whether you'd like to collaborate, discuss digital projects, or simply connect — feel free to get in touch.",
        phoneNumber: '06 05 60 85 36',
        location: 'France (Paris, Bordeaux)',
        contractDuration: 'Apprenticeship',
        grayscaleLabel: 'Enable or disable grayscale mode',
        backToTop: 'Back to the top of the page',
        actionPhoto: 'Action photo {{number}}'
      }
    }
  },
  es: {
    translation: {
      nav: { experiences: 'Experiencia', projects: 'Proyectos', services: 'Habilidades', contact: 'Contacto' },
      footer: { tagline: 'Desarrolladora frontend apasionada por React y TypeScript.', home: 'Inicio', projects: 'Proyectos', resume: 'CV', contact: 'Contacto', copyright: 'Todos los derechos reservados.' },
      home: {
        greeting: 'Hola, soy',
        role: 'Desarrolladora Frontend • React y TypeScript',
        intro: 'Busco una alternancia de 2 años para convertirme en asistente de jefe de proyecto, con sólidas competencias en desarrollo frontend.',
        downloadCv: 'Descargar mi CV',
        contactMe: 'Contactarme',
        discover: 'Descubrir',
        personalProjects: 'Mis proyectos personales recientes',
        professionalProjects: 'Proyectos profesionales en empresa',
        academicProjects: 'Proyectos académicos',
        viewProject: 'Ver proyecto',
        viewDetails: 'Ver detalles',
        product: 'El producto',
        operation: 'Funcionamiento',
        technologies: 'Tecnologías',
        viewRecommendation: 'Ver recomendación',
        skills: 'Mis habilidades',
        skillsSubtitle: 'Programas y tecnologías que utilizo',
        experienceSubtitle: 'Mis experiencias profesionales más relevantes',
        recommendations: 'Recomendaciones',
        recommendationsSubtitle: 'Opiniones de personas con las que he tenido el placer de colaborar',
        education: 'Mi formación',
        educationSubtitle: 'Realizada en los últimos años',
        contactTitle: 'Contáctame',
        contactSubtitle: 'Si deseas colaborar, hablar sobre proyectos digitales o simplemente conversar, no dudes en contactarme.',
        phoneNumber: '06 05 60 85 36',
        location: 'Francia (París, Burdeos)',
        contractDuration: 'Aprendizaje',
        grayscaleLabel: 'Activar o desactivar el modo gris',
        backToTop: 'Volver al inicio de la página',
        actionPhoto: 'Foto de acción {{number}}'
      }
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('language') || 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false }
});

export default i18n;
